module.exports = __webpack_public_path__ + "static/media/google.4b6197dd.png";